/* tslint:disable */
/* eslint-disable */
/**
 * GlassHouse.Dashboard.Api | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { GetTimeEntryResponse } from './GetTimeEntryResponse';
import {
    GetTimeEntryResponseFromJSON,
    GetTimeEntryResponseFromJSONTyped,
    GetTimeEntryResponseToJSON,
    GetTimeEntryResponseToJSONTyped,
} from './GetTimeEntryResponse';
import type { ApiUserTasksGetPageParameter } from './ApiUserTasksGetPageParameter';
import {
    ApiUserTasksGetPageParameterFromJSON,
    ApiUserTasksGetPageParameterFromJSONTyped,
    ApiUserTasksGetPageParameterToJSON,
    ApiUserTasksGetPageParameterToJSONTyped,
} from './ApiUserTasksGetPageParameter';

/**
 * 
 * @export
 * @interface PaginatedResultOfGetTimeEntryResponse
 */
export interface PaginatedResultOfGetTimeEntryResponse {
    /**
     * 
     * @type {Array<GetTimeEntryResponse>}
     * @memberof PaginatedResultOfGetTimeEntryResponse
     */
    items?: Array<GetTimeEntryResponse>;
    /**
     * 
     * @type {any}
     * @memberof PaginatedResultOfGetTimeEntryResponse
     */
    lastSelectedId?: any | null;
    /**
     * 
     * @type {ApiUserTasksGetPageParameter}
     * @memberof PaginatedResultOfGetTimeEntryResponse
     */
    pageNumber?: ApiUserTasksGetPageParameter;
    /**
     * 
     * @type {ApiUserTasksGetPageParameter}
     * @memberof PaginatedResultOfGetTimeEntryResponse
     */
    pageSize?: ApiUserTasksGetPageParameter;
    /**
     * 
     * @type {ApiUserTasksGetPageParameter}
     * @memberof PaginatedResultOfGetTimeEntryResponse
     */
    totalCount?: ApiUserTasksGetPageParameter;
    /**
     * 
     * @type {boolean}
     * @memberof PaginatedResultOfGetTimeEntryResponse
     */
    hasNextPage?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PaginatedResultOfGetTimeEntryResponse
     */
    hasPreviousPage?: boolean;
}

/**
 * Check if a given object implements the PaginatedResultOfGetTimeEntryResponse interface.
 */
export function instanceOfPaginatedResultOfGetTimeEntryResponse(value: object): value is PaginatedResultOfGetTimeEntryResponse {
    return true;
}

export function PaginatedResultOfGetTimeEntryResponseFromJSON(json: any): PaginatedResultOfGetTimeEntryResponse {
    return PaginatedResultOfGetTimeEntryResponseFromJSONTyped(json, false);
}

export function PaginatedResultOfGetTimeEntryResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): PaginatedResultOfGetTimeEntryResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'items': json['items'] == null ? undefined : ((json['items'] as Array<any>).map(GetTimeEntryResponseFromJSON)),
        'lastSelectedId': json['lastSelectedId'] == null ? undefined : json['lastSelectedId'],
        'pageNumber': json['pageNumber'] == null ? undefined : ApiUserTasksGetPageParameterFromJSON(json['pageNumber']),
        'pageSize': json['pageSize'] == null ? undefined : ApiUserTasksGetPageParameterFromJSON(json['pageSize']),
        'totalCount': json['totalCount'] == null ? undefined : ApiUserTasksGetPageParameterFromJSON(json['totalCount']),
        'hasNextPage': json['hasNextPage'] == null ? undefined : json['hasNextPage'],
        'hasPreviousPage': json['hasPreviousPage'] == null ? undefined : json['hasPreviousPage'],
    };
}

export function PaginatedResultOfGetTimeEntryResponseToJSON(json: any): PaginatedResultOfGetTimeEntryResponse {
    return PaginatedResultOfGetTimeEntryResponseToJSONTyped(json, false);
}

export function PaginatedResultOfGetTimeEntryResponseToJSONTyped(value?: PaginatedResultOfGetTimeEntryResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'items': value['items'] == null ? undefined : ((value['items'] as Array<any>).map(GetTimeEntryResponseToJSON)),
        'lastSelectedId': value['lastSelectedId'],
        'pageNumber': ApiUserTasksGetPageParameterToJSON(value['pageNumber']),
        'pageSize': ApiUserTasksGetPageParameterToJSON(value['pageSize']),
        'totalCount': ApiUserTasksGetPageParameterToJSON(value['totalCount']),
        'hasNextPage': value['hasNextPage'],
        'hasPreviousPage': value['hasPreviousPage'],
    };
}

